import { render } from "./OrdersManagerOffersList.vue?vue&type=template&id=88323f16&scoped=true"
import script from "./OrdersManagerOffersList.vue?vue&type=script&lang=js"
export * from "./OrdersManagerOffersList.vue?vue&type=script&lang=js"

import "./OrdersManagerOffersList.vue?vue&type=style&index=0&id=88323f16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88323f16"]])

export default __exports__